import { useState } from 'react';

/**
 * input 커스텀 훅스
 * @author
 * */
const useInput = (defaultValue) => {
  const [value, setValue] = useState(defaultValue);

  const onChange = (e) => {
    // console.log({ e });
    const { target } = e || {};
    const { value } = target || {};
    setValue(value || e);
  };

  return { value, onChange };
};

export default useInput;
